import { Button } from '@acpaas-ui/react-components';
import { INPUT_STATES } from '../forms/forms.utils';
import TextField from '../forms/TextField';

const SimpleSearch = ({ className = '', description = '', query, canSearch = true, onChange, onSearch, onClear }) => {
  const handleKeyDown = (event) => {
    if (event.code === 'Enter' && canSearch) {
      onSearch();
    }
  };

  return (
    <div className={`spo-m-simple-search ${className} ${description ? 'has-description' : ''}`}>
      <TextField
        label="Zoeken"
        state={INPUT_STATES.DEFAULT}
        value={query}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        description={description}
      />
      {!!query && (
        <div className="spo-m-simple-search__clear">
          <Button icon="ai-remove" outline type="danger" onClick={onClear} />
        </div>
      )}
      <Button className="spo-m-simple-search__search" icon="ai-search" onClick={onSearch} disabled={!canSearch} />
    </div>
  );
};

export default SimpleSearch;
